import React from "react";
// import spinner from "img/spinner.gif";
import spinner from "img/color-spinner.gif";

export default () => (
  <div className="position-absolute d-flex justify-content-center align-items-center" style={{
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.2)",
      zIndex: 100
  }}>
    <img
      src={spinner}
      style={{
          width: 100,
          margin: "auto",
          display: "block"
      }}
      alt="Loading..."
    />
  </div>
);
